import React from "react";
import {
  Badge,
  Dialog, DialogActions, DialogContent, DialogProps,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props extends DialogProps {
  onClose?: () => void;
  children: React.ReactElement;
}

/**
 * 右上に×ボタンがあるダイアログ。  
 * 入力欄がありデータ送信が発生するようなケースを想定。  
 */
const FormDialog: React.FC<Props> = ({ onClose, children, ...rest }: Props) => {
  return (
    <Dialog onClose={onClose} disableRestoreFocus={true} closeAfterTransition={true} {...rest}>
      <DialogActions style={styles.action}>
        <IconButton color="inherit">
          <Badge color="secondary">
            <CloseIcon
              style={styles.closeIcon}
              onClick={onClose}
            />
          </Badge>
        </IconButton>
      </DialogActions>
      <DialogContent>
        { children }
      </DialogContent>
    </Dialog>
  )
}
export default FormDialog

const styles = {
  action: {
    marginBottom: 0,
    height: 15,
    marginTop: 10,
  },
  closeIcon: {
    color: "gray",
    width: 15,
    height: 15
  },
}
